"use client";
import Breadcrumbs from "@/components/breadCrumbAndButton/BreadCrumbAndButton";
import { useState } from "react";
import "./style.css";
import Link from "next/link";

export default function ContactUsClientPage() {
  const [newsletterData, setNewsletterData] = useState({
    name: "",
    email: "",
    message: "",
    checkBox: false,
  });

  const [errors, setErrors] = useState<{
    name?: string;
    email?: string;
    message?: string;
    checkBox?: string;
  }>({});

  const handleNewsletterChange = (field: string, value: any) => {
    setNewsletterData((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const submitForm = async (e: React.FormEvent) => {
    e.preventDefault();

    const newErrors: {
      name?: string;
      email?: string;
      message?: string;
      checkBox?: string;
    } = {};
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!newsletterData.name.trim()) {
      newErrors.name = "Enter Name!";
    } else if (newsletterData.name.length < 3) {
      newErrors.name = "Name must be at least 3 letters!";
    }

    if (!newsletterData.email.trim()) {
      newErrors.email = "Enter Email!";
    } else if (!emailRegex.test(newsletterData.email)) {
      newErrors.email = "Enter valid email!";
    }
    if (!newsletterData.message.trim() || newsletterData.message.length <= 10) {
      newErrors.message = "Message must be 10 letters";
    }
    if (!newsletterData.checkBox) {
      newErrors.checkBox = "Fill The Check Box!";
    }
    if (Object.keys(newErrors).length) {
      setErrors(newErrors);
      return;
    }

    try {
      const res = await fetch("/api/enquiry", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(newsletterData),
      });

      const data = await res.json();
      console.log("Enquiry Response:", data);

      if (res.ok) {
        alert("Enquiry Send Successfully!"); // simple browser alert
        setNewsletterData({
          name: "",
          email: "",
          message: "",
          checkBox: false,
        });
        setErrors({});
      } else {
        alert("Enquiry failed!");
      }
    } catch (err) {
      console.error("Enquiry error:", err);
      alert("Server error!");
    }
  };

  return (

    <div className="gh-container top-header-page-padding">
      <Breadcrumbs

        items={[{ label: "Home", href: "/" }, { label: "Contact Us" }]}
      />


      {/* Hero Section */}
      <div className="post-head page-head mt-3">
        <div className="post-head-wrapper page-head-wrapper position-relative">
          <picture>
            <source
              srcSet="https://cdn.coinccinos.com/content/images/size/w1600/format/webp/2025/12/Contact-Us---coinccino-1.webp"
              sizes="90vw"
              type="image/webp"
            />
            <img
              src="https://cdn.coinccinos.com/content/images/size/w1600/2025/12/Contact-Us---coinccino-1.webp"
              alt="Contact Us"
              className="post-feature-image w-100"
            />
          </picture>

          <div className="post-head-content position-absolute bottom-0 start-0 w-100 text-white p-4">
            <div className="post-head-content-container">
              <h1 className="post-page-title">Contact Us</h1>
              <p className="post-page-excerpt">
                To communicate with the administration of coinccinos.com, you
                have the contact form available within this page.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Main Section */}
      <main className="main">
        <div className="gh-container py-5 template-contact-container px-0">
          {/* Row 2 Columns */}
          <div className="row align-items-center">
            {/* Left Column */}
            <div className="col-lg-6 contact-form-container d-flex flex-column justify-content-center">
              <h1 className="mb-4 fw-bold">Contact Us</h1>

              <p className="mb-4">
                To communicate with the administration of coinccinos.com, you
                have the contact form accessible within this page.
                Alternatively, you can send an email to the dedicated email
                address or directly contact the administrative manager of
                coinccinos.com.
              </p>

              <div className="wpcf7 js" id="wpcf7-f407-o2">
                <div className="screen-reader-response">
                  <p role="status"></p>
                  <ul></ul>
                </div>
              </div>
            </div>

            {/* Right Column Image */}
            <div className="col-lg-6 text-center">
              <img
                src="/contact.png"
                className="img-fluid mt-4 mt-lg-0"
                alt="Contact Illustration"
                loading="lazy"
              />
            </div>
          </div>
          <div className="gh-container py-5">
            <div className="row g-4 align-items-start">
              {/* LEFT COLUMN - Newsletter */}
              <div className="col-lg-6 col-md-12">
                <h2 className="mb-4">Send a Message</h2>
                <form
                  className="contact-form-modern"
                  noValidate
                  onSubmit={submitForm}
                >
                  <div className="contact-input-wrapper">
                    <input
                      className="contact-input"
                      type="text"
                      placeholder="Name"
                      value={newsletterData.name}
                      onChange={(e) =>
                        handleNewsletterChange("name", e.target.value)
                      }
                    />

                    <input
                      className="contact-input"
                      type="email"
                      placeholder="Email"
                      value={newsletterData.email}
                      onChange={(e) =>
                        handleNewsletterChange("email", e.target.value)
                      }
                    />

                    <textarea
                      className="contact-input contact-textarea"
                      placeholder="Message"
                      value={newsletterData.message}
                      onChange={(e) =>
                        handleNewsletterChange("message", e.target.value)
                      }
                    />
                  </div>

                  <div className="form-check mt-3 d-flex align-items-center gap-2">
                    <input
                      className="form-check-input custom-checkbox"
                      type="checkbox"
                      id="terms"
                      checked={newsletterData.checkBox}
                      onChange={(e) =>
                        handleNewsletterChange("checkBox", e.target.checked)
                      }
                    />
                    <label
                      className="form-check-label"
                      htmlFor="terms"
                      style={{ fontSize: "14px" }}
                    >
                      I have read and agree to the{" "}
                      <strong>
                        <Link href={"/terms-of-services"}>
                          Terms & Conditions
                        </Link>
                      </strong>
                    </label>
                  </div>

                  {errors.name && (
                    <small className="text-danger d-block mt-1">
                      {errors.name}
                    </small>
                  )}
                  {errors.email && (
                    <small className="text-danger d-block mt-1">
                      {errors.email}
                    </small>
                  )}
                  {errors.message && (
                    <small className="text-danger d-block mt-1">
                      {errors.message}
                    </small>
                  )}
                  {errors.checkBox && (
                    <small className="text-danger d-block mt-1">
                      {errors.checkBox}
                    </small>
                  )}

                  <div className="d-flex justify-content-end mt-4">
                    <button className="contact-submit-button" type="submit">
                      Submit
                    </button>
                  </div>
                </form>
              </div>

              {/* RIGHT COLUMN - Contact Box */}
              <div className="col-lg-6 col-md-12">
                <div
                  className="contact-box-color rounded-3 p-4 mt-5 dark:text-black"
                  style={{ background: "#f0f0f0" }}
                >
                  <div className="row align-items-center">
                    {/* Address */}
                    <div className="col-lg-6 mb-3 mb-lg-0">
                      <h4 className="fw-bold mb-2">Coinccino Limited</h4>
                      <address className="mb-0">
                        Phone:
                        <a href="tel:+919409417394" className="text-black">
                          +91 9409417394
                        </a>
                      </address>
                    </div>
                    {/* Emails */}

                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <h5 className="fw-bold">General</h5>
                        <a
                          href="mailto:info@coinccinos.com"
                          style={{ color: "var(--ghost-accent-color)" }}
                        >
                          info@coinccinos.com
                        </a>
                      </div>
                      <div className="col-md-6">
                        <h5 className="fw-bold">Marketing & Sales</h5>
                        <a
                          href="mailto:info@coinccinos.com"
                          style={{ color: "var(--ghost-accent-color)" }}
                        >
                          info@coinccinos.com
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>

  );
}
